/**
 * @generated SignedSource<<ffb6b3bfa9cb70f878431750d530e0f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutLayout_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutFooter_viewer" | "CheckoutHelp_viewer" | "CheckoutMobileSummaryNewPane_viewer" | "CheckoutSidebar_viewer" | "CheckoutSteps_viewer">;
  readonly " $fragmentType": "CheckoutLayout_viewer";
};
export type CheckoutLayout_viewer$key = {
  readonly " $data"?: CheckoutLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutLayout_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutLayout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryNewPane_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebar_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutFooter_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSteps_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutHelp_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "eef4caa19b3e680edc8064368410b177";

export default node;
